"use client";

import { Skeleton } from "@/components/ui/skeleton";

export const OrderItemSkeleton = () => {
  return (
    <div className="pt-8 px-4 pb-2 flex gap-4 border-b border-stroke-light">
      <Skeleton variant="muted" className="size-15.5 rounded-xs" />

      <div className="space-y-3 w-full">
        <div className="flex items-center justify-between w-full">
          <div className="flex items-center gap-2">
            <Skeleton variant="muted" className="h-4 w-16" />
            <Skeleton variant="muted" className="h-4 w-12" />
          </div>
          <Skeleton variant="muted" className="h-4 w-24" />
        </div>
        <div className="flex items-center justify-between w-full">
          <Skeleton variant="muted" className="h-4 w-20" />
          <Skeleton variant="muted" className="h-4 w-24" />
        </div>
      </div>
    </div>
  );
};
